<template>
	<div class="sourceCode-card" ref="cardRef">
		<el-card 
			:body-style="{ padding: '20px 20px 10px 20px' }" 
			@click.native="handleDownload"
			shadow="hover">
			<div class="sourceCode-card-img-area">
				<img 
					v-lazy="sourceCode.logo" 
					class="image" />
				<div class="card-new" v-if="sourceCode.newStatus != 0">
					{{ statusMap[sourceCode.newStatus] }}
				</div>
				<!-- <svg-icon 
					v-if="!user || user.id === userInfo.id" 
					icon-class="collected" 
					:class-name="['hover-show', 'icon-collect-btn', isCollect ? 'active' : '']" 
					@click.native.stop="handleCollect"></svg-icon> -->
				<el-button 
					class="hover-show download-btn" 
					type="primary" >查看详情</el-button>
				<!-- <div class="sourceCode-card-format">{{ sourceCode.formatList | filterName('、') }}</div> -->
			</div>
			<div class="sourceCode-card-info">
				<div class="sourceCode-card-info-name" :title="sourceCode.name">{{ sourceCode.name }}</div>
				<div class="sourceCode-card-info-category">{{ sourceCode.categoryList | filterName(' / ') }}</div>
				<div class="sourceCode-card-info-addition">
					<template v-if="sourceCode.price" >
						<span v-if="sourceCode.paid" class="sourceCode-card-info-price-tag paid">已购买</span>
						<span v-else class="sourceCode-card-info-price-tag needPay">￥<b>{{sourceCode.price}}</b></span>
						<!-- <div class="file-type">
							<img class="file-type-icon" v-for="item in (sourceCode.formatList ||[])" :src="iconList[item.name]"></img>
						</div> -->
					</template>
					<span v-else class="sourceCode-card-info-price-tag free">免费</span>
					<div class="file-type">
						<img class="file-type-icon" v-if="iconList[item.name]" v-for="item in (sourceCode.formatList ||[])" :src="iconList[item.name]"></img>
					</div>
					<!-- <span style="float: right"><i class="el-icon-download"></i>{{ sourceCode.downloads }}</span> -->
				</div>
				<!-- <div class="sourceCode-card-info-tag">
					<el-tag 
						v-for="(label, index) in sourceCode.labelList" 
						type="info" 
						:key="index">#{{ label.name }}</el-tag>
				</div> -->
			</div>
		</el-card>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import {
    collectSourceCode,
    cancelCollectSourceCode
} from '@/api/sourceCode';

export default {
	name: 'SourceCodeCard',
	inject: ['checkToken'],
	filters: {
		filterName(list, format) {
			return list && list.map(item => item.categoryName).join(format);
		}
	},
	props: {
		sourceCode: {
			type: Object,
			required: true
		},
		// 素材归属用户
		user: {
			type: Object,
			required: false
		},
	},
	data() {
		return {
			// 是否已收藏
			isCollect: false,
			collectMethod: collectSourceCode,
			cancelCollectMethod: cancelCollectSourceCode,
			// sourceCodeInfo: {}
			statusMap:{
				'1': '新源码',
				'2': '特价',
				'3': '免费'
			},
			iconList: {
				'3dmax': require('@/assets/images/fileIcon/3dmax.svg'),
				'aep': require('@/assets/images/fileIcon/aep.svg'),
				'ai': require('@/assets/images/fileIcon/ai.svg'),
				'blend': require('@/assets/images/fileIcon/blend.svg'),
				'c4d': require('@/assets/images/fileIcon/c4d.svg'),
				'cclibs': require('@/assets/images/fileIcon/cclibs.svg'),
				'fbx': require('@/assets/images/fileIcon/fbx.svg'),
				'fig': require('@/assets/images/fileIcon/fig.svg'),
				'obj': require('@/assets/images/fileIcon/obj.svg'),
				'psd': require('@/assets/images/fileIcon/psd.svg'),
				'sketch': require('@/assets/images/fileIcon/sketch.svg'),
				'svg': require('@/assets/images/fileIcon/svg.svg'),
				'unity': require('@/assets/images/fileIcon/unity.svg'),
				'xd': require('@/assets/images/fileIcon/xd.svg'),
				'png': require('@/assets/images/fileIcon/png.svg'),
				'unreal': require('@/assets/images/fileIcon/unreal.svg'),
				'babylon': require('@/assets/images/fileIcon/babylon.svg'),
				'threejs': require('@/assets/images/fileIcon/threejs.svg'),
				'tif': require('@/assets/images/fileIcon/tif.svg'),
				'pptx':require('@/assets/images/fileIcon/pptx.svg')
			}
		}
	},
	computed: {
		...mapState('user', ['userInfo']),
	},
	watch: {
		'sourceCode.collection'() {
			this.isCollect = this.sourceCode.collection !== 0;
		}
	},
	created() {
		this.isCollect = this.sourceCode.collection !== 0;
	},
	mounted() {
		this.$refs.cardRef.oncontextmenu = () => false;
	},
	methods: {
		// 点击收藏
		handleCollect: debounce(function() {
			if (!this.checkToken()) return ;

			this[this.isCollect ? 'cancelCollectMethod' : 'collectMethod']({
				// userId: this.userInfo.id, 
				sourceCodeId: this.sourceCode.id
			}).then(() => {
				this.$message.success(this.isCollect ? '已取消收藏' : '收藏成功');
				this.isCollect = !this.isCollect;
			});
		}, 300),
		// 点击立即下载
		handleDownload() {
			// if (!this.checkToken()) return ;
			this.$emit('set-source-code', this.sourceCode);
		},
	}
}
</script>

<style lang="scss" scoped>
.sourceCode-card {
	.el-card {
		border: none;
		height: 365px;
		border-radius: 8px;
		cursor: pointer;
		&.is-hover-shadow{
			transform: translate(0, 0);
			transition: transform .3s;

			&:hover {
				box-shadow: 0 4px 12px rgba(0, 0, 0, .03), 0 8px 16px rgba(0, 0, 0, .02);
				transform: translate(0, -5px);
				.sourceCode-card-img-area img {
					transform: scale(1.05);
				}
				.sourceCode-card-img-area .hover-show {
					opacity: 1;
				}
				.sourceCode-card-info-name {
					color: #2f54eb;
				}
			}
		}
		/deep/ .el-card__body {
			padding: 0!important;
		}
	}
	&-img-area {
		position: relative;
		// margin-bottom: 20px;
		height: 239px;
		overflow: hidden;
		.image {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		.hover-show {
			position: absolute;
			opacity: 0;
			transition: .5s;
		}
		.icon-collect-btn {
			left: 10px;
			top: 10px;
		}
		.download-btn {
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			box-shadow: 999px 999px 10px 0px rgba(0, 0, 0, .2);
			background: transparent;
			border: transparent;
			&-img {
				margin-right: 5px;
				width: 16px;
				vertical-align: bottom;
			}
		}
		.card-new {
			width: 76px;
			height: 30px;
			background: #FA5151;
			opacity: 1;
			color: #fff;
			text-align: center;
			line-height: 30px;
			border-radius: 0 0 4px 0;
			font-size: 16px;
			position: absolute;
			left: 0;
			top: 0;
		}
	}
	&-format {
		position: absolute;
		bottom: 0;
		padding: 0 20px;
		background: rgba(0, 0, 0, .2);
		width: 100%;
		color: #fff;
		font-size: 12px;
		line-height: 40px;
	}
	&-info {
		padding: 10px 12px 14px 12px;
		overflow: hidden;
		&-name {
			@include ellipse(100%);
			font-size: 16px;
			font-weight: 400
		}
		&-category {
			margin: 10px 0;
			color: #999;
			font-size: 13px;
			min-height: 30px;
			// display: -webkit-box;
			text-overflow: ellipsis;
			white-space: nowrap;
			// -webkit-line-clamp: 2;
			// -webkit-box-orient: vertical;
			overflow: hidden;
		}
		&-addition {
			color: #999;
			font-size: 13px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.file-type {
				display: flex;
				align-items: center;
			}
			.file-type-icon {
				width: 26px;
				height: 26px;
				margin-right: 3px;
			}
		}
		&-tag {
			margin: 20px 0 10px 0;
			max-height: 60px;
			overflow: hidden;
			& /deep/ .el-tag {
				margin: 0 10px 10px 0;
				padding: 0 15px;
				border-radius: 20px;
				border: none;
				height: 25px;
				line-height: 25px;
				font-size: 12px;
			}
		}
		&-price-tag {
			&.free {
				color: #1BC8BC; 
				font-weight: 600;
			}
			&.needPay, &.paid {
				padding: 2px 0;
				border-radius: 4px;
				color: #fff; 
				font-weight: 600;
			}
			&.needPay {
				color: #eb793c;
				font-size: 12px;
				b {
					font-size: 18px;
					font-weight: 600;
				}
			}
			&.paid {
				border: 1px solid #eb793c;
				color: #eb793c;
				padding: 2px 6px;
			}
		}
	}
}
@include mq($small) {
    .source-code-card {
		.el-card {
			height: 420px;
		}

	}
}
</style>
